export default "__VITE_ASSET__DIriIRaj__"